import "./App.css";
import LoadingSpinner from "./controls/LoadingSpinner";
import { useState } from "react";
import { Routes, Route } from 'react-router-dom';


import Home from "./pages/Home";
import Calculator from "./pages/Calculator";

function App() {
  const [scaleVal] = useState(1);

  return (

         <div className={["App"].join(" ")}>
           <LoadingSpinner />
        <Routes>
          <Route path="/" element={<Home scaleVal={scaleVal} />} />
          <Route path="/calculator" element={<Calculator />} />
        </Routes>

   </div>

   );
}

export default App;
